import React from 'react';

export const RegisterSvg = () => (
  <svg
    width="72px"
    height="72px"
    viewBox="0 0 72 72"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path
        id="register-path-1"
        d="M0,36 C0,16.1187272 16.1187272,0 36,0 C55.8812728,0 72,16.1187272 72,36 C72,55.8812728 55.8812728,72 36,72 C16.1187272,72 0,55.8767451 0,36"
      />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-871, -155)">
        <g transform="translate(871, 155)">
          <mask id="register-mask-2" fill="white">
            <use xlinkHref="#register-path-1"></use>
          </mask>
          <g id="Group" mask="url(#register-mask-2)" fillRule="nonzero">
            <path
              d="M0,36 C0,16.1187272 16.1187272,0 36,0 C55.8812728,0 72,16.1187272 72,36 C72,55.8812728 55.8812728,72 36,72 C16.1187272,72 0,55.8767451 0,36"
              fill="#e6d1e5"
            />
            <path
              d="M14.6083019,74.2686792 L57.3962264,74.2686792 C57.3962264,74.2686792 57.3962264,17.1667925 57.3962264,17.1667925 C57.3962264,15.3871698 55.9516981,13.9426415 54.1720755,13.9426415 L24.434717,13.9426415 C24.434717,13.9426415 14.6083019,23.7690566 14.6083019,23.7690566 L14.6083019,74.2686792 Z"
              fill="#F7F7F7"
            />
            <polygon
              fill="#EAEAEA"
              points="24.434717 23.7690566 14.6083019 23.7690566 24.434717 13.9426415"
            />
            <rect
              fill="#EAEAEA"
              x="17.4430189"
              y="28.9041509"
              width="37.1230189"
              height="1.09132075"
            ></rect>
            <rect
              fill="#EAEAEA"
              x="17.4430189"
              y="34.8226415"
              width="37.1230189"
              height="1.09132075"
            ></rect>
            <rect
              fill="#EAEAEA"
              x="17.4430189"
              y="40.7411321"
              width="37.1230189"
              height="1.09132075"
            ></rect>
            <rect
              fill="#EAEAEA"
              x="17.4430189"
              y="46.6596226"
              width="37.1230189"
              height="1.09132075"
            ></rect>
            <rect
              fill="#EAEAEA"
              x="17.4430189"
              y="52.5781132"
              width="37.1230189"
              height="1.09132075"
            ></rect>
            <rect
              fill="#EAEAEA"
              x="17.4430189"
              y="58.4966038"
              width="37.1230189"
              height="1.09132075"
            ></rect>
            <path
              d="M17.6558491,58.2158491 L17.2256604,56.8890566 C19.349434,56.2007547 21.9396226,54.8150943 24.0769811,52.9901887 C23.3433962,49.8520755 23.52,45.9079245 24.6203774,43.7796226 C25.5667925,41.9501887 26.8664151,41.9773585 27.554717,42.1584906 C28.8633962,42.4981132 29.6422642,43.6573585 29.6875472,45.3328302 C29.7509434,47.5335849 28.4784906,50.7079245 25.6528302,53.4928302 C26.0015094,54.5932075 26.4633962,55.4716981 27.0067925,55.9290566 C27.6362264,56.4588679 28.2249057,56.6490566 28.8,56.5086792 C30.1132075,56.1962264 31.1818868,54.2988679 31.485283,53.5924528 L32.7667925,54.1403774 C32.7124528,54.2716981 31.3766038,57.3237736 29.1215094,57.8626415 C28.0981132,58.1071698 27.0837736,57.8128302 26.1101887,56.9932075 C25.4535849,56.4407547 24.9237736,55.5667925 24.5298113,54.5071698 C22.7411321,55.9924528 20.4633962,57.3056604 17.6558491,58.2113208 L17.6558491,58.2158491 Z M26.9524528,43.4671698 C26.6807547,43.4671698 26.2732075,43.6166038 25.8566038,44.4181132 C24.8830189,46.3018868 24.7924528,49.349434 25.2588679,51.8807547 C27.0928302,49.9924528 28.365283,47.7509434 28.2973585,45.3735849 C28.2792453,44.7803774 28.1162264,43.7433962 27.2015094,43.5079245 C27.1426415,43.4943396 27.0566038,43.4716981 26.9479245,43.4716981 L26.9524528,43.4671698 Z"
              fill="#0C4571"
            />
            <path
              d="M39.1698113,22.754717 C38.2596226,24.3486792 38.6716981,26.4045283 40.3924528,28.8588679 C41.7328302,30.7743396 43.3403774,32.1826415 43.4083019,32.2415094 L43.5713208,32.3818868 C43.6392453,32.4407547 43.7298113,32.4543396 43.8113208,32.4271698 L44.0150943,32.3501887 C44.0150943,32.3501887 46.0754717,31.5667925 48.0135849,30.2218868 C50.4769811,28.5101887 51.5728302,26.7260377 51.2739623,24.914717 C51.0384906,23.4973585 50.1509434,22.4920755 48.8377358,22.1569811 C47.714717,21.8671698 46.4150943,22.1388679 45.4460377,22.8633962 L45.3871698,22.9086792 L45.3464151,22.845283 C44.7350943,21.9079245 43.725283,21.2332075 42.6656604,21.0430189 C42.5796226,21.029434 42.4935849,21.0158491 42.4075472,21.0067925 C41.0581132,20.8664151 39.8807547,21.5049057 39.1698113,22.7501887"
              fill="#EC2031"
            />
            <path
              d="M48.8819984,22.0086341 L51.1642625,22.0086341 C51.9793569,22.0086341 52.6450173,22.6697662 52.6450173,23.4893889 L52.6450173,60.6803323 L47.4012437,60.6803323 L47.4012437,23.4848606 C47.4012437,22.6697662 48.0623757,22.0041058 48.8819984,22.0041058 L48.8819984,22.0086341 Z"
              fill="#A1C9DD"
              transform="translate(50.0231, 41.3422) rotate(43.44) translate(-50.0231, -41.3422)"
            />
            <path
              d="M55.3236753,25.7911132 L55.759147,25.7911132 C56.4992085,25.7911132 57.099147,26.3910517 57.099147,27.1311132 L57.099147,38.8556415 C57.099147,39.5957031 56.4992085,40.1956415 55.759147,40.1956415 L55.3236753,40.1956415 C54.5836137,40.1956415 53.9836753,39.5957031 53.9836753,38.8556415 L53.9836753,27.1311132 C53.9836753,26.3910517 54.5836137,25.7911132 55.3236753,25.7911132 Z"
              fill="#88AABB"
              transform="translate(55.5414, 32.9934) rotate(43.44) translate(-55.5414, -32.9934)"
            />
            <path
              d="M33.1516981,58.4784906 L34.8271698,53.5788679 L38.6354717,57.1833962 L33.8354717,59.1215094 C33.4279245,59.2845283 33.0113208,58.8950943 33.1562264,58.4784906 L33.1516981,58.4784906 Z"
              fill="#88AABB"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
